import { render, staticRenderFns } from "./WarehouseLocationSearchComponent.vue?vue&type=template&id=06ae0596"
import script from "./WarehouseLocationSearchComponent.vue?vue&type=script&lang=js"
export * from "./WarehouseLocationSearchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports